export default "__VITE_ASSET__CyrRjjee__"